import type { ReactNode } from 'react';
import { Button } from '../../Buttons';
import styles from './BaseCard.module.css';

export interface BaseCardProps {
	title: string;
	subtitle?: string;
	actionButton?: { label: string; onClick: () => void; disabled?: boolean };
	footerSlot?: ReactNode;
	stretch?: boolean;
	children: ReactNode;
}

export const BaseCard = ({
	title,
	subtitle,
	actionButton,
	footerSlot,
	stretch = false,
	children,
}: BaseCardProps) => {
	return (
		<div className={`${styles.card} ${stretch ? styles.cardStretch : ''}`}>
			<div className={styles.header}>
				<div className={styles.headerContent}>
					<span className={styles.title}>{title}</span>
					{subtitle && <span className={styles.subtitle}>{subtitle}</span>}
				</div>
				{actionButton && (
					<Button
						variant="secondary"
						className={styles.actionBtn}
						onClick={actionButton.onClick}
						disabled={actionButton.disabled}
					>
						{actionButton.label}
					</Button>
				)}
			</div>

			{children}
			{footerSlot}
		</div>
	);
};
